import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import 'react-circular-progressbar/dist/styles.css';
import './resources/Styles.css'
import { Provider } from "react-redux";
import { Snackbar } from 'react-redux-snackbar';
import Store from "./redux/Store";


ReactDOM.render(
    <Provider store={Store}>
    <div>
        <App />
        <Snackbar />
    </div>
    </Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
